import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FaArrowRight, FaCode, FaRocket, FaUsers } from 'react-icons/fa';
import heroImage from '../../assets/hero-image.jpg';
import './Hero.css';

const Hero = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const stats = [
    { icon: <FaCode />, number: '500+', label: 'Projects Completed' },
    { icon: <FaUsers />, number: '200+', label: 'Happy Clients' },
    { icon: <FaRocket />, number: '5+', label: 'Years Experience' },
  ];

  return (
    <section className="hero">
      <div className="hero-background">
        <img src={heroImage} alt="Hero Background" />
        <div className="hero-overlay"></div>
      </div>
      
      <div className="hero-content">
        <div className="container">
          <div className="hero-grid">
            <div className={`hero-text ${isVisible ? 'animate-slideInLeft' : ''}`}>
              <span className="hero-subtitle">Welcome to Redfox Digital</span>
              <h1 className="hero-title">
                Transform Your
                <span className="hero-highlight"> Digital Presence</span>
                <br />with Expert Solutions
              </h1>
              <p className="hero-description">
                Unlock your business potential with Redfox Digital - where innovation meets 
                excellence. We create stunning websites, powerful e-commerce platforms, and 
                digital solutions that drive real results for your business.
              </p>
              <div className="hero-buttons">
                <Link to="/contact" className="btn btn-primary">
                  Get Started Today
                  <FaArrowRight className="btn-icon" />
                </Link>
                {/*<Link to="/portfolio" className="btn btn-secondary">
                  View Our Work
                </Link>*/}
              </div>
            </div>
            
            <div className={`hero-stats ${isVisible ? 'animate-slideInRight' : ''}`}>
              <div className="hero-stats-grid">
                {stats.map((stat, index) => (
                  <div key={index} className="hero-stat-card" style={{animationDelay: `${index * 0.2}s`}}>
                    <div className="hero-stat-icon">{stat.icon}</div>
                    <div className="hero-stat-number">{stat.number}</div>
                    <div className="hero-stat-label">{stat.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/*<div className="hero-scroll-indicator">
        <div className="scroll-arrow"></div>
      </div>*/}
    </section>
  );
};

export default Hero;